// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ad-z","fullWidth":"Bd-z","heading":"Cd-z","fullBleed":"Dd-z","hidden":"Ed-z"};